<template>
  <div>
    <v-btn
      class="ma-0 text-capitalize"
      color="secondary"
      depressed
    >
      <strong>Featured Videos</strong>
    </v-btn>

    <v-container
      grid-list-xl
      px-0
    >
      <h2>Recent Classes</h2>
      <v-row>
        <v-col
          v-for="(video, i) in videos"
          :key="i"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex"
        >
          <v-hover close-delay="0">
            <template v-slot="{ hover }">
              <v-card
                :elevation="hover ? 2 : 8"
                hover
                class="pa-2"
              >
                <div class="pa-3">
                  <v-img
                    :aspect-ratio="16/9"
                    :src="video.img"
                    contain
                  />
                </div>

                <v-card-title
                  class="title primary--text"
                  v-text="video.name"
                />

                <v-divider class="ma-2" />

                <v-row
                  class="font-weight-medium ma-0 pa-0"
                  tag="v-card-text"
                >
                  <v-col cols="6">
                    <div
                      v-for="feature in video.features.slice(0, 4)"
                      :key="feature"
                      class="text-caption text-uppercase font-weight-medium mb-2"
                      v-text="feature"
                    />
                  </v-col>
                  <v-col cols="6">
                    <div
                      v-for="feature in video.features.slice(4, 8)"
                      :key="feature"
                      class="text-caption text-uppercase font-weight-medium mb-2"
                      v-text="feature"
                    />
                  </v-col>

                  <v-card-actions class="grow">
                    <div class="px-1">
                      <div class="primary--text title font-weight-bold">
                        30 mins
                      </div>
                    </div>
                    <v-spacer />
                    <v-btn
                      fab
                      depressed
                    >
                      <v-icon>mdi-video</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-row>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    data: () => ({
      videos: [
        {
          name: 'All-level Ballet',
          features: [
            '50 mins barre',
            'feature 2',
            'feature 3',
            'feature 4',
            '10 mins center'
          ],
          price: 30,
          originalPrice: 30,
          img: require('@/assets/tablet.png')
        }
      ]
    })
  }
</script>
